export default {
      id: "cart-usage",
      viewBox: "0 0 512 456",
      url: __webpack_public_path__ + "img/svg-sprite.svg#cart",
      toString: function () {
        return this.url;
      }
    }